var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-container"},[(_vm.error)?_c('div',{staticClass:"redirect-error"},[_c('p',[_vm._v(_vm._s(_vm.error))])]):_c('div',[_vm._v("\n        Redirecting you...\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }